import React from 'react';
import Header from './header/Header';
import Sidebar from './sidebar/Sidebar';
import Body from './body/Body';
import Footer from './footer/Footer';

const Layout = () => {
    return (
        <div className="d-flex flex-column vh-100">
            <Header/>
            <div className="d-flex flex-grow-1 overflow-hidden">
                <Sidebar/>
                <Body/>
            </div>
            <Footer/>
        </div>
    );
};

export default Layout;
